/* batida-v7-kalendarz.js: Kalendarz okazji on the shop (3.10.2026, Aleksandra's mock-up docs/ops/2026-10-03-kalendarz-okazji).
   Two places, both filled from Batida Connect (GET /apps/connect/kalendarz, the app proxy; contract in batida-connect
   CLAUDE.md §1b):
   - [data-v7kal-page]  the page /pages/kalendarz (sections/batida-v7-kalendarz.liquid): the nearest occasion, the list
     by month with filters, today's / tomorrow's name days (with the CC BY-SA credit), "Przypomnij mi", closed days;
   - [data-v7kal-strip] the "Najbliższe okazje" strip on the home page (sections/batida-v7-kalendarz-pasek.liquid): the 4
     nearest occasions; when it shows, it takes the place of the "Okazja?" row (that row stays if the calendar is off).
   Nothing is invented: with the calendar switched off in Connect (or no answer) the page keeps its server-rendered
   list of occasion pages and the strip stays hidden. An occasion links only when its Shopify page exists (metaobject
   "Okazje", passed in by Liquid as cfg.pages); otherwise it is shown without a link (Aleksandra 3.10).
   Dates are Warsaw calendar days ("YYYY-MM-DD"); month and day names come from Intl in the shop's language. */
(function () {
  'use strict';
  /* 5.10: site = the shop's occasion list in Connect (cfg.site "b2b" on b2b.batida.pl, sections/batida-b2b-kalendarz;
     none = batida.pl, the request is the same as before) */
  var cache = {};
  var WINDOW = 60;   /* 5.10 (Aleksandra): the list shows the next 60 days, the rest behind "Pokaż więcej" */
  function load(lang, site) {
    var k = lang + '|' + (site || '');
    if (!cache[k]) {
      cache[k] = fetch('/apps/connect/kalendarz?days=400&lang=' + encodeURIComponent(lang) + (site ? '&site=' + encodeURIComponent(site) : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[k];
  }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(s, vars) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : ''; }); }
  function ymd(s) { var p = String(s).split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])); }
  function diff(a, b) { return Math.round((ymd(b) - ymd(a)) / 864e5); }
  function dm(s) { var p = String(s).split('-'); return (+p[2]) + '.' + p[1]; }
  function fmt(loc, s, o) { try { o.timeZone = 'UTC'; return new Intl.DateTimeFormat(loc, o).format(ymd(s)); } catch (e) { return dm(s); } }
  function cap(t) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
  /* 4.10 (Aleksandra 17:17): "Zamów dziś do 21:00 - tort z imieniem będzie na jutro" only while tomorrow can still be
     ordered today (Connect's rule: 24 h products until 21:00 the day before, nothing handed over on Sundays and closed
     days). Otherwise nd_cta_later with the real days: "Zamów do niedzieli do 21:00 - tort z imieniem będzie w poniedziałek".
     assets/batida-nextday.js does the counting (this page's closed days and cut-off); without it the old line stays. */
  function ndCta(j, T) {
    var N = window.BatidaNextDay, info = N && N.compute(N.now(), j.closed, j.nextDayCutoff);
    if (!info || info.deadlineToday || !T.nd_cta_later) return tpl(T.nd_cta, { godzina: j.nextDayCutoff });
    return N.fill(T.nd_cta_later, N.vars(info));
  }
  function readCfg(root) { try { return JSON.parse(root.querySelector('[data-v7kal-cfg]').textContent); } catch (e) { return null; } }

  /* every calendar entry, sorted: occasions (kind sweet/custom), holidays not already an occasion that day, closed days */
  function entries(j) {
    var today = j.today, out = [], occDays = {}, closed = {};
    (j.closed || []).forEach(function (c) { closed[c.date] = true; });
    (j.occasions || []).forEach(function (o) {
      if ((o.until || o.date) < today) return;
      occDays[o.date] = true;
      out.push({ t: 'occ', date: o.date, until: o.until, name: o.name, id: o.id, orderBy: o.orderBy, orderUntil: o.orderUntil, limited: o.limited, collection: o.collection });
    });
    var holDays = {};
    (j.holidays || []).forEach(function (h) {
      if (h.date < today) return;
      holDays[h.date] = true;
      var isClosed = h.closed || closed[h.date];
      if (occDays[h.date] && !isClosed) return;                       /* Wielkanoc, Wigilia: the occasion says it */
      out.push({ t: isClosed ? 'closed' : 'hol', date: h.date, name: h.name, hol: true });
    });
    Object.keys(closed).forEach(function (d) { if (d >= today && !holDays[d]) out.push({ t: 'closed', date: d, name: '' }); });
    out.sort(function (a, b) { return a.date < b.date ? -1 : a.date > b.date ? 1 : (a.t === 'occ' ? -1 : 1); });
    return out;
  }
  function pageOf(cfg, id) { return cfg.pages && cfg.pages[id] ? cfg.pages[id] : null; }
  function badge(cfg, d) { return '<span class="v7kal-day"><b>' + esc(+d.split('-')[2]) + '</b><span>' + esc(fmt(cfg.locale, d, { month: 'short' }).replace('.', '').toUpperCase()) + '</span></span>'; }
  function orderLine(cfg, e) {
    if (!e.orderBy) return '';
    return esc(tpl(cfg.t.order_by, { data: dm(e.orderBy) }));
  }

  /* ---------------- the strip on the home page ---------------- */
  function strip(root) {
    var cfg = readCfg(root); if (!cfg) return;
    load(cfg.lang).then(function (j) {
      if (!j || !j.ok || !j.enabled) return;
      var occ = entries(j).filter(function (e) { return e.t === 'occ'; }).slice(0, cfg.limit || 4);
      if (!occ.length) return;
      root.querySelector('[data-v7kal-items]').innerHTML = occ.map(function (e) {
        var pg = pageOf(cfg, e.id);
        /* 5.10 (Aleksandra, Halloween 2026): a "Wyróżniona okazja" block of the section (cfg.promo[id]) replaces the
           tile's texts for that occasion - title, date line, short text, button - and its link (e.g. the collection).
           No block = the tile exactly as before. */
        var pr = cfg.promo && cfg.promo[e.id];
        if (pr) {
          /* 5.10 late (Aleksandra): the tile is short - date badge, name, button. No date line / "zamów do" and no description. */
          var pin = badge(cfg, e.date) + '<span class="v7kal-s__txt"><b>' + esc(pr.title || e.name) + '</b>' +
            (pr.btn ? '<span class="v7kal-s__cta">' + esc(pr.btn) + '</span>' : '') + '</span>';
          var href = pr.url || (pg && pg.url);
          return href ? '<a class="v7kal-s__it v7kal-s__it--promo" href="' + esc(href) + '">' + pin + '</a>' : '<span class="v7kal-s__it v7kal-s__it--promo">' + pin + '</span>';
        }
        var inner = badge(cfg, e.date) + '<span class="v7kal-s__txt"><b>' + esc(e.name) + '</b><span>' + orderLine(cfg, e) + '</span></span>';
        return pg ? '<a class="v7kal-s__it" href="' + esc(pg.url) + '">' + inner + '</a>' : '<span class="v7kal-s__it">' + inner + '</span>';
      }).join('');
      root.hidden = false;
      /* the strip takes the place of the "Okazja?" row (sections/batida-v7-okazje.liquid) */
      var row = document.querySelector('[data-v7ok]');
      var sec = row && row.closest('.shopify-section');
      if (sec && cfg.replace_row) sec.hidden = true;
    });
  }

  /* ---------------- the calendar page ---------------- */
  function page(root) {
    var cfg = readCfg(root); if (!cfg) return;
    var T = cfg.t || {};
    /* 5.10 (b2b calendar, preview): cfg.flag = the section exists only with ?podglad=<flag>; without it nothing is asked */
    if (cfg.flag && !new RegExp('[?&]podglad=' + cfg.flag + '(?:&|$)').test(location.search)) return;
    load(cfg.lang, cfg.site).then(function (j) {
      if (!j || !j.ok || !j.enabled) return;                          /* keeps the server-rendered list of occasion pages */
      var all = entries(j), today = j.today, loc = cfg.locale;
      root.classList.add('is-live');
      if (cfg.flag || cfg.reveal) root.hidden = false;   /* b2b section: rendered hidden, shown once Connect answers (5.10 published) */

      /* the nearest occasion */
      var near = all.filter(function (e) { return e.t === 'occ'; })[0], nb = root.querySelector('[data-v7kal-near]');
      if (near && nb) {
        var pg = pageOf(cfg, near.id), n = diff(today, near.date);
        var when = near.until ? tpl(T.range, { od: fmt(loc, near.date, { day: 'numeric', month: 'long' }), do: fmt(loc, near.until, { day: 'numeric', month: 'long' }) }) : fmt(loc, near.date, { day: 'numeric', month: 'long' });
        var count = n <= 0 ? esc(T.today) : n === 1 ? esc(T.tomorrow) : '<b>' + n + '</b><span>' + esc(T.days) + '</span>';
        var see = pg ? pg.url : (near.collection ? cfg.root + 'collections/' + near.collection : '');
        nb.innerHTML = '<p class="v7kal-near__k">' + esc(T.near) + '</p>' +
          '<div class="v7kal-near__row"><div><h2 class="v7kal-near__h">' + esc(near.name) + '</h2><p class="v7kal-near__when">' + esc(when) + '</p>' +
          (pg && pg.lead ? '<p class="v7kal-near__lead">' + esc(pg.lead) + '</p>' : '') +
          (near.limited && T.limited ? '<p class="v7kal-lim">' + esc(T.limited) + '</p>' : '') + '</div>' +
          '<div class="v7kal-near__count">' + count + (near.orderBy ? '<p class="v7kal-near__by">' + orderLine(cfg, near) + '</p>' : '') + '</div></div>' +
          '<p class="v7kal-near__btns">' + (see ? '<a class="v7kal-btn v7kal-btn--dark" href="' + esc(see) + '">' + esc(T.see_btn) + '</a>' : '') +
          (cfg.remind_url ? '<a class="v7kal-btn" href="' + esc(cfg.remind_url) + '">' + esc(T.remind_btn) + '</a>' : '') + '</p>';
        nb.hidden = false;
      }

      /* the list by month. 5.10 (Aleksandra 16:14): by default only the next WINDOW days (rolling: counted from Connect's
         "today", Warsaw); the rest behind "Pokaż więcej" (T.more). Every filter works the same way: 60 days + "Pokaż więcej".
         A running range (Galette des Rois) counts by its first day, so it is always inside. */
      var win = cfg.windowDays || WINDOW;
      var list = root.querySelector('[data-v7kal-list]'), month = '', html = '';
      all.forEach(function (e) {
        var m = e.date.slice(0, 7);
        if (m !== month) { html += (month ? '</ul>' : '') + '<h3 class="v7kal-m">' + esc(cap(fmt(loc, e.date, { month: 'long', year: 'numeric' }))) + '</h3><ul class="v7kal-ul" role="list">'; month = m; }
        var kind = e.t === 'occ' ? 'sweet' : e.t === 'hol' ? 'hol' : 'closed', pg = e.t === 'occ' ? pageOf(cfg, e.id) : null;
        var sub = e.t === 'occ' ? (pg && pg.lead ? pg.lead : '') : e.t === 'hol' ? T.hol_text : T.closed_text;
        var right = e.t === 'occ' ? '<span class="v7kal-by">' + orderLine(cfg, e) + '</span>' + (pg ? '<a class="v7kal-go" href="' + esc(pg.url) + '">' + esc(T.see) + '</a>' : '')
          : e.t === 'closed' ? '<span class="v7kal-pill">' + esc(T.closed_badge) + '</span>' : '';
        var far = diff(today, e.date) >= win;
        html += '<li class="v7kal-it" data-kind="' + kind + (e.hol && e.t === 'closed' ? ' hol' : '') + '"' + (far ? ' data-v7kal-far' : '') + '>' + badge(cfg, e.date) +
          '<div class="v7kal-it__txt"><b>' + esc(e.name || T.closed_day) + (e.until ? ' <span class="v7kal-rng">' + esc(dm(e.date) + ' - ' + dm(e.until)) + '</span>' : '') + '</b>' +
          (sub ? '<span>' + esc(sub) + '</span>' : '') + (e.limited && T.limited ? '<span class="v7kal-lim">' + esc(T.limited) + '</span>' : '') + '</div>' +
          '<div class="v7kal-it__r">' + right + '</div></li>';
      });
      if (list) {
        list.innerHTML = html ? html + '</ul>' : '';
        /* under the list: the "nothing in the next 60 days" line (a filter can be empty there, e.g. B2B occasions in
           October) and the "Pokaż więcej" button */
        if (T.more && !root.querySelector('[data-v7kal-more]')) {
          list.insertAdjacentHTML('afterend', '<p class="v7kal-empty" data-v7kal-empty hidden>' + esc(T.empty || '') + '</p>' +
            '<p class="v7kal-more"><button type="button" class="v7kal-btn" data-v7kal-more hidden>' + esc(T.more) + '</button></p>');
        }
        apply();
      }
      var tabs = root.querySelector('[data-v7kal-tabs]'); if (tabs) tabs.hidden = false;

      /* name days (today, tomorrow) + the credit their licence asks for */
      var nd = j.namedays, nbx = root.querySelector('[data-v7kal-nd]');
      if (nd && nbx && ((nd.today && nd.today.names.length) || (nd.tomorrow && nd.tomorrow.names.length))) {
        var src = nd.source || {};
        nbx.innerHTML = '<p class="v7kal-box__k">' + esc(T.nd_today) + '</p><p class="v7kal-nd">' + esc((nd.today.names || []).slice(0, 6).join(', ')) + '</p>' +
          '<p class="v7kal-box__k">' + esc(T.nd_tomorrow) + '</p><p class="v7kal-nd">' + esc((nd.tomorrow.names || []).slice(0, 6).join(', ')) + '</p>' +
          (j.nextDayCutoff && T.nd_cta ? '<p class="v7kal-nd__cta">' + esc(ndCta(j, T)) + '</p>' : '') +
          '<p class="v7kal-credit">' + tpl(esc(T.credit), { wikipedia: '<a href="' + esc(src.url) + '" target="_blank" rel="noopener">' + esc(T.credit_wiki) + '</a>', licencja: '<a href="' + esc(src.licenseUrl) + '" target="_blank" rel="noopener">' + esc(src.license || 'CC BY-SA 4.0') + '</a>' }) + '</p>';
        nbx.hidden = false;
      }

      /* closed days. 5.10 (Aleksandra 16:14, batida.pl and b2b): the full list, no longer the first 8 (they ended at 29.03 and
         cut 1.05, 3.05, 27.05 and 15.08 off although Connect sends them). The dates have no year, so the list stops before
         a day.month comes back (1.11.2027 after 1.11.2026) = one year. cfg.closedMax (> 0) can still cap it. Which days are
         closed is Connect data (availability blackouts); 2.05 was taken out there on 5.10. */
      var cseen = {}, cds = [], cstop = false;
      all.forEach(function (e) {
        if (e.t !== 'closed' || cstop) return;
        var k = dm(e.date); if (cseen[k]) { cstop = true; return; }
        cseen[k] = true; cds.push(e);
      });
      if (cfg.closedMax > 0) cds = cds.slice(0, cfg.closedMax);
      var cb = root.querySelector('[data-v7kal-closed]');
      if (cb && cds.length) {
        cb.querySelector('[data-v7kal-closed-list]').textContent = cds.map(function (e) { return dm(e.date); }).join(', ');
        cb.hidden = false;
      }
    });

    /* filters + "Pokaż więcej": the filter picks the kind, the window hides what is WINDOW days or more away until
       "Pokaż więcej" is pressed; choosing a filter starts again from the 60 days (Aleksandra 5.10: filters work the same way) */
    var filter = 'all', more = false;
    function apply() {
      var f = filter, shown = 0, farLeft = 0;
      root.querySelectorAll('.v7kal-it').forEach(function (li) {
        var k = li.getAttribute('data-kind'); if (k == null) return;   /* the server-rendered fallback list */
        var kindOk = f === 'all' || (f === 'sweet' && k === 'sweet') || (f === 'hol' && (k === 'hol' || k === 'closed hol')) || (f === 'closed' && k.indexOf('closed') === 0);
        var far = li.hasAttribute('data-v7kal-far');
        li.hidden = !(kindOk && (more || !far));
        if (!li.hidden) shown++; else if (kindOk && far) farLeft++;
      });
      root.querySelectorAll('.v7kal-ul').forEach(function (ul) {
        var any = [].some.call(ul.children, function (li) { return !li.hidden; });
        ul.hidden = !any; var h = ul.previousElementSibling; if (h && h.classList.contains('v7kal-m')) h.hidden = !any;
      });
      var mb = root.querySelector('[data-v7kal-more]'), em = root.querySelector('[data-v7kal-empty]');
      if (mb) { mb.hidden = !farLeft; mb.parentNode.hidden = !farLeft; }
      if (em) em.hidden = !!shown || !em.textContent;
    }
    root.addEventListener('click', function (ev) {
      var m = ev.target.closest && ev.target.closest('[data-v7kal-more]');
      if (m) { more = true; apply(); return; }
      var b = ev.target.closest && ev.target.closest('[data-v7kal-f]'); if (!b) return;
      filter = b.getAttribute('data-v7kal-f'); more = false;
      root.querySelectorAll('[data-v7kal-f]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      apply();
    });
  }

  function init() {
    document.querySelectorAll('[data-v7kal-strip]').forEach(strip);
    document.querySelectorAll('[data-v7kal-page]').forEach(page);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
